<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'master-costumer',
};
</script>

<style>
</style>
